import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { environment } from "src/environments/environment";

export interface Country {
  countryCode: string;
  countryName: string;
  currency: string;
  flagFile: string;
  measurementUnits: string;
  weightUnits: string;
}
@Injectable({
  providedIn: "root",
})
export class CountriesService {
  public countries = signal<Country[]>([]);
  private http = inject(HttpClient);
  apiUrl = environment.baseApiUrl + "/entity/country";

  clearCache(): void {
    this.countries.set([]);
  }
  // private mockData: Country[] = [
  //   {
  //     countryCode: "US",
  //     countryName: "United States",
  //     currency: "USD",
  //     flagFile: "https://flagcdn.com/us.svg",
  //     measurementUnits: "inches",
  //     weightUnits: "pounds",
  //   },
  //   {
  //     countryCode: "CA",
  //     countryName: "Canada",
  //     currency: "CAD",
  //     flagFile: "https://flagcdn.com/ca.svg",
  //     measurementUnits: "centimeters",
  //     weightUnits: "kilograms",
  //   },
  //   {
  //     countryCode: "MX",
  //     countryName: "Mexico",
  //     currency: "MXN",
  //     flagFile: "https://flagcdn.com/mx.svg",
  //     measurementUnits: "centimeters",
  //     weightUnits: "kilograms",
  //   },
  // ]; // Mock data here

  constructor() {}

  get(): Observable<Country[]> {
    return this.http
      .get<Country[]>(this.apiUrl)
      .pipe(tap((countries) => this.countries.set(countries)));
  }

  getCachedOrLoad(): Observable<Country[]> {
    const cached = this.countries();
    return cached.length > 0 ? of(cached) : this.get();
  }
}
